export const environment = "STAGE"; // PROD or STAGE

export let variables, Moengage;

if (environment === "PROD") {
  variables = {
    ADMIN_URL: "https://meds-gateway-api.curebay.com/api-gateway",
    Check_Auth: "https://meds-gateway-api.curebay.com/api-gateway",
    version: "4",
    mixPanelKey: "5c3d71d8969d07eade7a841605f12ebb",
    WHOLESALE_URL: "https://meds-gateway-api.curebay.com/api-gateway",
    CureCoinUrl: "https://affinity.curebay.com/affinity",
    CartUrl: "https://cart.curebay.com/cart",
    CheServiceUrl: "https://che-services.curebay.com/che-services/",
    CoinRedemptionUrl: "https://meds-gateway-api.curebay.com/api-gateway",
    eagleUrl: "https://eaglebackend.curebay.com",
    partnerStatementUrl:
      "https://connect.curebay.com/api/zoho/getPartnerStatement",
    MedDistributionUrl: "https://meds-api-common.curebay.com/meds-common",
    LifelineUrl: "https://lifeline.curebay.com/",
    appVersionCode: 191,
  };
  Moengage = window.moe({
    // app_id: "3AR8DRLKA6RERFNQ9FN4SPL4",
    debug_logs: 0,
    swPath: "/service-worker.js",
  });
} else {
  variables = {
    ADMIN_URL: "https://med-gateway-stage.curebay.in/api-gateway",
    Check_Auth: "https://med-gateway-stage.curebay.in/api-gateway",
    version: "4",
    mixPanelKey: "5c3d71d8969d07eade7a841605f12ebb",
    // eagleUrl: "https://eagledev.clinn.in/api",
    WHOLESALE_URL: "https://med-gateway-stage.curebay.in/api-gateway",
    CureCoinUrl: "https://affinity-stage.curebay.in/affinity",
    CartUrl: "https://cart-stage.curebay.in/cart",
    CheServiceUrl: "https://che-services-stage.curebay.in/che-services",
    CoinRedemptionUrl: "https://med-gateway-stage.curebay.in/api-gateway",
    eagleUrl: "https://eaglebackend.curebay.com",
    partnerStatementUrl:
      "https://connect-new-stage.curebay.in/api/zoho/getPartnerStatement",
    MedDistributionUrl: "https://meds-stage.curebay.in/curebay-med",
    LifelineUrl: "https://lifeline-stage.curebay.in",
    appVersionCode: 191,
  };
  Moengage = window.moe({
    // app_id: "3AR8DRLKA6RERFNQ9FN4SPL4",
    debug_logs: 1,
    swPath: "/service-worker.js",
  });
}
Object.freeze(variables);
Object.freeze(Moengage);

export const Maps = {
  MAPS_API_KEY: "AIzaSyB4bv_dbewMr5lSjhJyWokBVWWgCvMs0uY",
};

export const updateDetails = {
  title: "what's new 🎉",
  description: "just some random update. nothing important!",
};
